import { render } from "./Episodes.vue?vue&type=template&id=d5482fdc&scoped=true"
import script from "./Episodes.vue?vue&type=script&setup=true&lang=js"
export * from "./Episodes.vue?vue&type=script&setup=true&lang=js"

import "./Episodes.vue?vue&type=style&index=0&id=d5482fdc&scoped=true&lang=css"

import exportComponent from "/home/runner/work/channel-xyz/channel-xyz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5482fdc"],['__file',"src/views/Episodes.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d5482fdc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d5482fdc', __exports__)) {
    api.reload('d5482fdc', __exports__)
  }
  
  module.hot.accept("./Episodes.vue?vue&type=template&id=d5482fdc&scoped=true", () => {
    api.rerender('d5482fdc', render)
  })

}


export default __exports__